import React from 'react';
import { Link } from 'react-router-dom';
import config from '../config';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-container">
          <div className="footer-section brand-section">
            <div className="footer-logo">
              <span className="logo-icon">🌿</span>
              <span className="logo-text">AURA</span>
            </div>
            <p className="footer-description">
              Authentic Kerala Ayurvedic Massage Therapy & Wellness Center. 
              Experience traditional healing with natural herbal oils and certified therapists.
            </p>
            <div className="footer-social">
              <p className="social-title">Follow Us</p>
              <div className="social-links">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                  <span>f</span>
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                  <span>📷</span>
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Twitter">
                  <span>🐦</span>
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="YouTube">
                  <span>▶</span>
                </a>
                <a href="https://whatsapp.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="WhatsApp">
                  <span>💬</span>
                </a>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Our Services</Link></li>
              <li><Link to="/booking">Book Appointment</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Popular Services</h3>
            <ul className="footer-links">
              <li><Link to="/services">Kerala Ayurvedic Massage</Link></li>
              <li><Link to="/services">Detoxification Therapy</Link></li>
              <li><Link to="/services">Stress Relief Treatment</Link></li>
              <li><Link to="/services">Holistic Healing</Link></li>
              <li><Link to="/services">Unisex Salon Services</Link></li>
            </ul>
          </div>

          <div className="footer-section contact-section">
            <h3 className="footer-title">Get In Touch</h3>
            <ul className="footer-contact">
              <li>
                <span className="contact-icon">📍</span>
                <div className="contact-info">
                  <strong>Address</strong>
                  <p>1st Floor, Medhi Building Tangra Satra Path, GS Road Rukmini Gaon</p>
                </div>
              </li>
              <li>
                <span className="contact-icon">📞</span>
                <div className="contact-info">
                  <strong>Phone</strong>
                  <p>{config.contact.phone}</p>
                </div>
              </li>
              <li>
                <span className="contact-icon">✉️</span>
                <div className="contact-info">
                  <strong>Email</strong>
                  <p>{config.contact.email}</p>
                </div>
              </li>
              <li>
                <span className="contact-icon">🕒</span>
                <div className="contact-info">
                  <strong>Working Hours</strong>
                  <p>Mon-Sun: 9:00 AM - 9:00 PM</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-middle">
        <div className="newsletter-section">
          <div className="newsletter-content">
            <h3>Book Your Ayurvedic Session</h3>
            <p>Booking Available via Phone & WhatsApp • Advance Appointment Recommended</p>
          </div>
          <div className="newsletter-form">
            <a href="tel:+91 7086453209 " className="newsletter-btn">Call Now</a>
            <a href="https://wa.me/916000503903" target="_blank" rel="noopener noreferrer" className="newsletter-btn whatsapp">WhatsApp</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="copyright">&copy; 2024 AURA Ayurveda & Wellness. All Rights Reserved.</p>
          <div className="footer-bottom-links">
            <a href="#privacy">Privacy Policy</a>
            <span className="separator">|</span>
            <a href="#terms">Terms & Conditions</a>
            <span className="separator">|</span>
            <a href="#sitemap">Sitemap</a>
          </div>
          <p className="developer-credit">Crafted with ❤️ for Premium Beauty Experience</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
